import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined'
import ConnectWithoutContactOutlinedIcon from '@mui/icons-material/ConnectWithoutContactOutlined'
import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined'
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined'
import { IconProps, SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'
import { i18nTranslationHelper } from '@/i18n'

export namespace ContentFormat {
  const t = {
    enuns: i18nTranslationHelper.getTEnums
  }
  export class Enum {
    static readonly ONSITE = new Enum(1, 'ONSITE', 'Presencial', PersonPinCircleOutlinedIcon)

    static readonly LIVE_STREAMING = new Enum(
      2,
      'LIVE_STREAMING',
      t.enuns('contentFormat.LIVE_STREAMING.name'),
      ConnectWithoutContactOutlinedIcon
    )

    static readonly ON_DEMAND_STREAMING = new Enum(
      3,
      'ON_DEMAND_STREAMING',
      t.enuns('contentFormat.ON_DEMAND_STREAMING.name'),
      PlayCircleFilledWhiteOutlinedIcon
    )

    static readonly PARTIALLY_ONSITE = new Enum(
      4,
      'PARTIALLY_ONSITE',
      t.enuns('contentFormat.PARTIALLY_ONSITE.name'),
      CastForEducationOutlinedIcon,
      t.enuns('contentFormat.PARTIALLY_ONSITE.description')
    )

    is(format: ContentFormat.Enum | null): boolean {
      return this.id === format?.id
    }

    public get Icon() {
      return this.icon as React.ComponentType<IconProps>
    }

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string,
      public readonly icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>,
      public readonly description?: string
    ) {}
  }

  export const getByName = (name: string): Enum => {
    return Object.values(ContentFormat.Enum).find(type => type.name === name)
  }

  export const getByTitle = (title: string): Enum => {
    return Object.values(ContentFormat.Enum).find(type => type.title === title)
  }

  export const getAll = (): Enum[] => {
    return Object.values(ContentFormat.Enum)
  }
}
